<template>
  <div class="invitation_container">
    <div class="invitation_box">
      <div class="bg_img_box">
        <img :src="require('@/assets/images/h5_code_back.png')" alt="" />
      </div>
      <div class="invite_info_box">
        <div class="user_portrait">
          <div class="img">
            <img :src="portrait" alt="">
          </div>
        </div>
        <div class="nick_name" v-text="nickName"></div>
        <div class="code" v-text="inviteCode"></div>
      </div>
    </div>
    <div class="tips_box"><span class="tips">长按邀请码复制</span></div>
    <div class="operate_tips_box">
      <p>1、请在注册时的“邀请码”输入框，输入上方邀请码，帮您的好友获取积分；</p>
      <p>2、每个账号注册时，只能使用一个邀请码。</p>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { loadStat } from "@/utils";
import inviteApi from "@/api/apis/invite.js";
import commApi from "@/api/apis/common.js";
export default {
  name: "Invitation",
  data() {
    return {
      inviteCode: null,
      nickName: "",
      headSrc: "",
      shareUrl: "",
    };
  },
  computed: {
    ...mapState("app", ["nodeCode", "appName", "appFullName"]),
    /* 头像 */
    portrait() {
      if (!!this.headSrc && this.headSrc.length > 0) {
        return this.headSrc;
      } else {
        return require("@/assets/images/user_default_invite.png");
      }
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (from.path == "/index_share") {
        vm.shareUrl = location.href.replace("/invitation?", "/index_share?");
      } else {
        vm.shareUrl = location.href;
      }
    });
  },
  methods: {
    /* 微信二次分享 */
    wechatShare() {
      var _this = this;

      commApi.getWeiXinTicket({
        nodeCode: _this.nodeCode,
        url: _this.shareUrl
      }).then((res) => {
        _this.$WeiXin.shareWeiXin(res, "我正在" + _this.appName + "邀请好友赚积分，快帮我", "下载" + _this.appFullName + "，了解更多精彩资讯", _this.shareUrl, null);
      }).catch((err) => {

      })
    },
    /* 获取发出邀请用户的信息 */
    getInviterInfo() {
      var _this = this;
      inviteApi
        .getInviterInfo({ inviteCode: _this.inviteCode })
        .then((res) => {
          if (res.suc == 1) {
            _this.nickName = res.data.nickName;
            _this.headSrc = res.data.portrait;
            _this.wechatShare(); // 微信二次分享
          } else {
            _this.$toast({
              message: res.message || res.text,
              position: "center",
            });
          }
        })
        .catch((err) => {
          _this.$toast({
            message: "接口调用出错",
            position: "center",
          });
        });
    },
  },
  created() {
    document.title = "邀请码";
    let query = this.$route.query;
    if (Object.prototype.hasOwnProperty.call(query, "inviteCode")) {
      this.inviteCode = query.inviteCode;
      this.getInviterInfo();
      loadStat(); // 友盟统计
    } else {
      this.$router.replace({
        path: "/error",
      });
    }
  },
};
</script>
<style scoped lang="scss">
.invitation_container {
  width: 100%;
  height: 100%;
  padding: 30px 0 0;
  overflow-x: hidden;
  overflow-y: auto;
  .invitation_box {
    position: relative;
    width: 60%;
    padding: 0 15px;
    margin: 0 auto 15px;
    color: #fff;
    text-align: center;
    .bg_img_box {
      width: 100%;
      margin: auto;
      img {
        display: block;
        width: 100%;
      }
    }
    .invite_info_box {
      position: absolute;
      top: 0px;
      left: 15px;
      z-index: 1;
      width: calc(100% - 30px);
      padding-top: 8.5%;
      height: 100%;
      text-align: center;
      .user_portrait {
        position: relative;
        width: 21%;
        height: 0;
        padding-bottom: 21%;
        margin: auto;
        background-image: url(~@/assets/images/user_default_invite.png);
        background-repeat: no-repeat;
        background-position: center;
        background-size: contain;
        .img {
          position: absolute;
          left: 0;
          top: 0;
          z-index: 2;
          width: 100%;
          height: 100%;
          img {
            display: block;
            width: 100%;
            height: 100%;
          }
        }
      }
      .nick_name {
        width: 100%;
        font-size: 4vw;
        line-height: 8vw;
      }
      .code {
        width: 100%;
        font-size: 5vw;
        line-height: 8vw;
      }
    }
  }
  .tips_box {
    width: 100%;
    line-height: 24px;
    padding-bottom: 12px;
    border-bottom: 1px solid #d6d6d6;
    margin-bottom: 12px;
    color: #838383;
    text-align: center;
    font-size: 13px;
  }
  .operate_tips_box {
    width: 100%;
    line-height: 24px;
    padding: 0 12px;
    margin-bottom: 36px;
    color: #646464;
    font-size: 13px;
  }
}
@media screen and (min-width: 750px) {
  .invitation_container {
    .invitation_box {
      .invite_info_box {
        .nick_name {
          font-size: 30px;
          line-height: 60px;
        }
        .code {
          font-size: 37.5px;
          line-height: 60px;
        }
      }
    }
  }
}
</style>